import type { DevEnv } from "@p0security/shared/types/environment";

import { p0WifPoolId, p0WifProviderId } from "./naming.ts";
import type { GcpWifIdentityConfig } from "./types.ts";

export const p0WifPoolTerraform = (
  context: DevEnv,
  data: { item: GcpWifIdentityConfig; installName: string }
) => {
  const { item, installName } = data;
  const { projectId, oidcProviderUrl } = item;
  const poolId = p0WifPoolId(context, installName);
  const providerId = p0WifProviderId(context, installName);

  return `locals {
  project_id        = "${projectId}"
  oidc_provider_url = "${oidcProviderUrl}"
}

resource "google_iam_workload_identity_pool" "p0_wif_pool" {
  project                   = local.project_id
  workload_identity_pool_id = "${poolId}"
}

resource "google_iam_workload_identity_pool_provider" "p0_wif_provider" {
  project                            = local.project_id
  workload_identity_pool_id          = google_iam_workload_identity_pool.p0_wif_pool.workload_identity_pool_id
  workload_identity_pool_provider_id = "${providerId}"

  attribute_mapping = {
    "google.subject" = "assertion.sub"
  }

  oidc {
    issuer_uri = local.oidc_provider_url
  }
}`;
};
